export default __webpack_public_path__ + "static/media/comingSoonBlue.272ce875.png";